// AutoGenerated
export enum EnmKatilimDurum {
    "Katıldı" = 1,
    "Katılmadı" = 2,
    "Geç Katıldı" = 3,
}